/**
 * Lets Clerk move between its own steps inside the page (21 Oct 2026).
 *
 * ClerkProvider sits above the router (App calls Clerk hooks before <BrowserRouter>), and with
 * no routerPush Clerk changes steps — email → password → code — by loading the whole page again.
 * Every Continue reloaded the sign-in page: Clerk started from scratch, the form disappeared and
 * came back. The router's navigate is handed to Clerk here (ClerkNavigationBridge); until the
 * router is mounted, Clerk falls back to a normal page load, as before.
 */

let navigateTo: ((to: string, replace: boolean) => void) | null = null

/** Set by ClerkNavigationBridge while the router is mounted. */
export function setClerkRouter(fn: ((to: string, replace: boolean) => void) | null) { navigateTo = fn }

/** For ClerkProvider's routerPush / routerReplace. Another site's address always loads normally. */
export function clerkNavigate(to: string, replace = false) {
  let path: string | null = null
  try {
    const u = new URL(to, window.location.origin)
    if (u.origin === window.location.origin) path = u.pathname + u.search + u.hash
  } catch { /* not a URL we understand: load it normally */ }
  if (navigateTo && path) navigateTo(path, replace)
  else if (replace) window.location.replace(to)
  else window.location.assign(to)
}
